import snapPixelInitSnippet from './snapPixelInitSnippet'

/**
 * Initialize the Snap pixel for the product's configured account, then fire PAGE_VIEW.
 * No-op when the product has no Snap account mapped.
 *
 * @param {string, number} productId
 * @returns {void}
 */
export const snapPixelInit = (productId) => {
  if (typeof window === 'undefined') return

  const normalizedId = productId?.toString()
  const pixelId = window.app.snapPixelAccounts?.find(({ productIds }) => productIds.includes(normalizedId))?.pixelId
  if (!pixelId) return

  snapPixelInitSnippet(pixelId)
  window.snaptr('track', 'PAGE_VIEW')
}
